import { useState } from "react";
import { authService } from "@services/authService";
import { useNavigate } from "react-router-dom";
import MyAccountUI from "./MyAccountUI";
import { IUser } from "src/types/global";
const MyAccount = () => {
  const navigate = useNavigate();
  const [showDialog, setShowDialog] = useState(false);
  const user = (JSON.parse(localStorage.getItem("user") || "{}") as IUser);
  const logout = () => {
    authService.logout();
    navigate("/login");
  };
  const handleOpen = () => setShowDialog(true);
  const handleClose = () => setShowDialog(false);
  return <MyAccountUI showDialog={showDialog} handleConfirmDialog={logout} handleOpenDialog={handleOpen} handleCloseDialog={handleClose} id={user.id} name={user.name} surname={user.surname} emailAddress={user.emailAddress} phoneNumber={user.phoneNumber} isAdmin={authService.isAdmin()} />;
};
export default MyAccount;